import React from 'react';

interface FilterDropdownProps {
  experienceLevelOptions?: { id: string; name: string }[];
  formData: {
    experienceLevel?: string;
  };
  handleChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
}

const EFilterDropdown: React.FC<FilterDropdownProps> = ({
  experienceLevelOptions = [],
  formData,
  handleChange,
}) => {
  return (
      <select
        name="experienceLevel"
        title="experienceLevel"
        className="flex-grow p-2 bg-transparent border-[3px] border-t-0 lg:border-[3px] font-medium border-primary focus:outline-none text-gray-800"
        value={formData.experienceLevel}
        onChange={handleChange}
      >
        <option value="">All Experience Level</option>
        {experienceLevelOptions.filter(level =>
          level.name === "Professional" ||
          level.name === "Freshgraduate" ||
          level.name === "Intern"
        ).map((level) => (
          <option key={level.id} value={level.name}>
            {level.name}
          </option>
        ))}
      </select>
  );
};

export default EFilterDropdown;
